import React from 'react'
import AdminMain from '../components/Admin/AdminMain'



export default function AdminUsers() {
  return (
     <div className="layout-body adminUsers">
     <AdminMain />
    </div>
  )
}
